import React from 'react';
import { styled } from '@mui/material';

interface LabelProps {
    children: React.ReactNode;
    htmlFor?: string;
    className?: string;
}

export function Label({ children, htmlFor, className }: LabelProps) {
    return (
        <StyledLabel htmlFor={htmlFor} className={className}>
            {children}
        </StyledLabel>
    );
}

const StyledLabel = styled('label')({
    fontSize: 14,
    fontWeight: 600,
    color: 'inherit',
});
